<template>
  <div id="basic">
    <el-row :gutter="10">
      <el-col :lg="14" :md="14">
        <div style="display: flex">
          <div style="margin-right: 20px; line-height: 40px">选择门店：</div>
          <el-select
            v-model="formInline.id"
            placeholder="请选择"
            @change="getList"
          >
            <el-option
              v-for="index in typeDate"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </div>

        <!-- </div> -->
      </el-col>
      <el-col :lg="10" :md="10">
        <div style="display: flex">
          <el-date-picker
            v-model="formInline.date"
            type="daterange"
            align="right"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-button @click="getDateTop" style="margin-left: 10px"
            >查询</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col class="colMaxBox" :xl="12" :md="12"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_name">
              销售额 <i class="el-icon-s-marketing iconFloat iconCol3"></i>
            </div>
            <div class="item_value">¥ &nbsp; &nbsp;{{ total_saleall | priceFilt }}</div>
          </div>
        </div>
      </el-col>

      <el-col class="colMaxBox" :xl="12" :md="12"
        ><div class="grid-content bg-purple">
          <div class="top_item">
            <div class="item_name">
              原料消耗 <i class="el-icon-s-promotion iconFloat iconCol4"></i>
            </div>
            <div class="item_value">¥ &nbsp; &nbsp;{{ total_raw_all | priceFilt }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="back">
          <div id="echart_A" style="width: 100%; height: 300px"></div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="40">
      <div style="margin-left: 40px; margin-bottom:20px; font-size: 17px">原料消耗清单:</div>
      <el-col :span="24">
        <div class="back">
          <el-table
              :fit="false"
              border
              :data="tableData"
              :cell-style="() => 'text-align: center;'"
              :header-cell-style="() => 'text-align: center;background:#eef1f6;'"
          >
            <template slot="empty">
              <noCart></noCart>
            </template>
            <el-table-column label="原料名称" width="180">
              <template slot-scope="scope">
                <span>{{scope.row.name}}</span>
              </template>
            </el-table-column>
            <el-table-column label="消耗数量" width="180">
              <template slot-scope="scope">
                <span>{{(scope.row.amount/1000.0).toFixed(2)}} {{scope.row.unit}}</span>
              </template>
            </el-table-column>
<!--            <el-table-column label="计量单位" width="180">-->
<!--              <template slot-scope="scope">-->
<!--                <span>{{scope.row.unit}}</span>-->
<!--              </template>-->
<!--            </el-table-column>-->
            <el-table-column label="原料单价" width="180">
              <template slot-scope="scope">
                <span>￥{{(scope.row.unit_price/100.0).toFixed(2)}}/{{scope.row.unit}}</span>
              </template>
            </el-table-column>
            <el-table-column label="消耗成本" width="180">
              <template slot-scope="scope">
                <span>￥{{scope.row.total_price/100}}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>

    </el-row>
  </div>
</template>

<script>
export default {
  name: 'employee',
  data() {
    return {
      formInline: {
        user: '',
        region: '',
        id: '',
        category_type: 1, // c_type|| 2外卖  1堂食
        date: null,
      },
      datalist: [],
      topValue: {},
      typeDate: [],
      tableData: [],
      total_saleall: 0,
      prepay_saleall: 0,
      ali_saleallall: 0,
      wechat_saleall: 0,
      member_saleall: 0,
      total_raw_all : 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '本月',
            onClick(picker) {
              picker.$emit('pick', [new Date(), new Date()]);
            },
          },
          {
            text: '今年至今',
            onClick(picker) {
              const end = new Date();
              const start = new Date(new Date().getFullYear(), 0);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setMonth(start.getMonth() - 6);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  created() {
    this.$root.headName = ['运营数据', '原料数据'];
  },
  mounted() {
    this.getType();
    //
  },
  methods: {
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.typeDate = res.data.items;
          this.formInline.id = res.data.items[0].id;
          this.formInline.date = [this.fastDate(true), this.getDate(true)];
          this.getList();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    drawLine() {
      let elementById = document.getElementById('echart_A');
      let echartsDemo = this.$echarts.init(elementById);
      const data = [],
          value = [],
          value2 = [];

      const exlist = this.topValue['device_order_sale_day'];
      const revenue = this.topValue['total_sale_day']
      if (exlist) {
        exlist.details.map((item) => {
          data.push(item.day);
          value.push(item.total_price/100.0);
        });
      }
      if (revenue) {
        revenue.map(item => {
          value2.push(item.total_price/100.0)
        })
      }
      let option = {
        title: {
          text: '原料消耗',
        },
        tooltip: {
          trigger: 'axis',
        },

        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {},
          },
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: data,
        },
        yAxis: {
          type: 'value',

          splitLine: { show: false },
        },
        series: [
          {
            name: '当日原料消耗',
            type: 'line',
            color: '#66CDAA',
            stack: '总量',
            data: value,
            label: {
              show: true,
            },
          },
          {
            name: '当日销售金额',
            type: 'line',
            color: '#483D8B',
            stack: '总量',
            data: value2,
            label: {
              show: true,
            },
          },
        ],
      };
      echartsDemo.setOption(option);
    },

    getDate(is) {
      var myDate = new Date();
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    fastDate(is) {
      var myDate = new Date(
        new Date().getTime() - 1000 * 3600 * 24 * 7
      );
      if (!is) {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m;
      } else {
        var tYear = myDate.getFullYear();
        var tMonth = myDate.getMonth();
        var Dates =
          myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate();
        var m = tMonth + 1 < 10 ? '0' + (tMonth + 1) : tMonth + 1;
        return tYear + '-' + m + '-' + Dates;
      }
    },
    getDateTime(nS) {
      var date = new Date(nS); //获取一个时间对象
      let y = date.getFullYear(); // 获取完整的年份(4位,1970)
      let m =
        date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1; // 获取月份(0-11,0代表1月,用的时候记得加上1)
      let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate(); // 获取日(1-31)
      let t = date.getTime() < 10 ? '0' + date.getTime() : date.getTime(); // 获取时间(从1970.1.1开始的毫秒数)
      let h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours(); // 获取小时数(0-23)
      let mm =
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes(); // 获取分钟数(0-59)
      let s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds(); // 获取秒数(0-59)
      return y + '-' + m + '-' + d;
    },
    getOld30() {
      let thirtyDays =
        new Date(new Date().toLocaleDateString()).getTime() -
        30 * 3600 * 24 * 1000; //最近30天
      return this.getDateTime(thirtyDays);
    },

    getList() {
      const shop_id = this.formInline.id;
      const data = {
        shop_id,
        indicators: [
          {
            value_type: 'device_order_sale',
            date_type: 'day',
            is_date_range: true,
            date_from: this.formInline.date[0],
            date_to: this.formInline.date[1],
          },
          {
            value_type: 'total_sale',
            date_type: 'day',
            is_date_range: true,
            date_from: this.formInline.date[0],
            date_to: this.formInline.date[1],
          },
        ],
      };

      const url = this.$userList.show_indicator;
      this.$http.post(url, data).then((res) => {
        if (res.code === 200) {
          this.datalist = res.data.results;
          this.setDatalist();
        }
      });
    },
    setDatalist() {
      const data = {};
      this.datalist.map((item) => {
        if (item.indicator.date) {
          data[item.indicator.value_type + '' + item.indicator.date] =
            (item.value && item.value.total_price / 100) || 0;
        } else {
          data[item.indicator.value_type + '_' + item.indicator.date_type] =
            item.value;
        }
      });
      this.topValue = data;
      this.tableData = this.topValue.device_order_sale_day.summary
      console.log('data: ', data);
      this.topDataMous(data);

      this.drawLine();
    },
    topDataMous(data) {
      const prepay_sale = data['prepay_sale_month'];
      const ali_sale = data['ali_sale_month'];

      const wechat_sale = data['wechat_sale_month'];
      const member_sale = data['member_sale_month'];

      const total_sale = data['total_sale_day']
      const raw_sale = data['device_order_sale_day'].details

      if (raw_sale) {
        let raw_sale_total = 0
        raw_sale.map(item => {
          raw_sale_total += item.total_price/100 || 0
        })
        this.total_raw_all = raw_sale_total
      }

      if (total_sale) {
        let total_sale_all = 0
        total_sale.map(item => {
          total_sale_all += item.total_price
        })
        this.total_saleall = total_sale_all/100 || 0
      }

      if (prepay_sale) {
        let prepay_saleall = 0;
        prepay_sale.map((item) => {
          prepay_saleall += item.total_price;
        });
        this.prepay_saleall = prepay_saleall / 100 || 0;
      }
      if (ali_sale) {
        let ali_saleallall = 0;
        ali_sale.map((item) => {
          ali_saleallall += item.total_price;
        });
        this.ali_saleallall = ali_saleallall / 100 || 0;
      }
      if (wechat_sale) {
        let wechat_saleall = 0;
        wechat_sale.map((item) => {
          wechat_saleall += item.total_price;
        });
        this.wechat_saleall = wechat_saleall / 100 || 0;
      }

      if (member_sale) {
        let member_saleall = 0;
        member_sale.map((item) => {
          member_saleall += item.total_price;
        });
        this.member_saleall = member_saleall / 100 || 0;
      }


    },
    getDateTop() {
      console.log(this.formInline.date);
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row :last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #fff;
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.295);
}
.back {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 0 0px rgba(0, 0, 0, 0.295) !important;
  box-sizing: border-box;
  padding: 20px 10px;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fcfa;
}
.colMaxBox {
  margin: 5px 0;
}
.top_item {
  box-sizing: border-box;
  padding: 10px 15px;
}
.item_value {
  font-size: 16px;
  line-height: 36px;
  font-weight: bold;
  width: 100%;
  text-align: left;
  color: #878787;
  box-sizing: border-box;
}
.iconCol1 {
  color: #41c300;
}
.iconCol2 {
  color: #00838f;
}
.iconCol3 {
  color: #eeb043;
}
.iconCol4 {
  color: #ed7f7e;
}
.iconCol5 {
  color: rgb(64, 158, 255);
}
.item_name {
  font-size: 14px;
  width: 100%;
  text-align: left;
  margin-top: 10px;

  color: #878787;
  box-sizing: border-box;
  overflow: hidden;
  .iconFloat {
    float: right;
    font-size: 25px;
  }
}
.istopflex {
  justify-content: space-between;
  align-items: center;
  display: flex;
}
</style>
